import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { isAuthenticated, getFarmInfo } from '../../helpers/session';

const PrivateRoute = ({ component: Component, ...rest }) =>
    <Route {...rest} render={(props) => {
        const farm = getFarmInfo();
        return (isAuthenticated() && farm && farm.farm_uuid === props.match.params.farmId)
            ? <Component {...props} />
            : <Redirect to='/logout' />
    }} />;

export default PrivateRoute;